/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import styled from "styled-components";

interface Props {
  children: React.ReactNode;
}

export const LDPostPill = ({ children }: Props) => (
  <>
    <GraySpan>[[</GraySpan>
    <RedSpan>{children}</RedSpan>
    <GraySpan>]]</GraySpan>
  </>
);

const GraySpan = styled.span`
  color: #cccccc;
`;
const RedSpan = styled.span`
  color: #904d4d;
`;
